// ----------------------------------------------------------------------------
// Разлогинивание пользователя
// ----------------------------------------------------------------------------



import authElements from "./auth-elements-object.js";



const ttAuthLogout = (event) => {
    if (event) {
        event.preventDefault();
    }

    fetch('/oauth/get_data.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({ logout: '1' })
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Сетевая ошибка сервера');
            }
            return response.json();
        })
        .then(data => {
            if (data.RES === 1) {
                authElements.headerTTUsers.forEach(headerTTUser => headerTTUser.style.display = 'none');
                authElements.headerTTAuthRegistrations.forEach(headerTTAuthRegistration => headerTTAuthRegistration.style.display = '');
                authElements.headerTTUserNames.forEach(headerTTUserName => headerTTUserName.textContent = '');

                window.ttUserIsLoggedIn = false;

                authElements.ttUserNickInForms.forEach(ttUserNickInForm => ttUserNickInForm.innerHTML = '');

                const url = new URL(window.location.href);
                const TTUserEmail = url.searchParams.get('TTUserEmail');
                const TTUserConfirm = url.searchParams.get('TTUserConfirm');

                if (TTUserEmail && TTUserConfirm) { // баг бесконечного входа в систему после выхода
                    window.location.href = '/myaccount/';
                } else {
                    const path = window.location.pathname;
                    if (path.includes('/myaccount/') || path.includes('/account/')) {
                        window.location.reload();
                    }
                }
            } else {
                window.location.href = '/myaccount/';
            }

            document.cookie = "v_ttAuth_scrollTop=; path=/; max-age=1";
            document.cookie = "v_ttAuth_Exec=; path=/; max-age=1";
            document.cookie = "v_ttAuth_URL=" + encodeURIComponent(window.location.href) + "; path=/; max-age=1";

        })
        .catch(error => {
            console.error('Произошла ошибка при отправке:', error);
        });

    return false;
}

export default ttAuthLogout;